export default "__VITE_ASSET__8f353e11__"